import {useCallback, useState} from 'react';

import {getStoredTimezone, saveTimezone} from '@shared/utils';

export const useTimezone = () => {
  const [timezone, setTimezoneState] = useState<string>(getStoredTimezone);

  const setTimezone = useCallback((tz: string) => {
    saveTimezone(tz);
    setTimezoneState(tz);
  }, []);

  return {timezone, setTimezone};
};
